import { render } from "./SharedDataKeysList.vue?vue&type=template&id=6f927e05"
import script from "./SharedDataKeysList.vue?vue&type=script&lang=js"
export * from "./SharedDataKeysList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__